import * as React from 'react';
import { Check } from '@mui/icons-material';
import ShippingContainer from 'assets/images/shipping-container.png';

export const PerDiemEmptyState: React.FC = () => {
  return (
    <div className="flex-grow flex flex-col items-center">
      <div className="py-2">
        <img src={ShippingContainer} alt="Shipping container" className="w-52 m-8" />
      </div>
      <div className="bg-blue-200 p-4 flex">
        <Check className="mr-3" />
        <h3 className="text-base text-gray-900">
          Create your per diem report by entering your shipping line, container type, and date
          range.
        </h3>
      </div>
    </div>
  );
};
PerDiemEmptyState.displayName = 'PerDiemArchive.SmartPerDiem.PerDiemEmptyState';
